<template>
    <div id="main">
        <div class="page page-container">
            <div class="content">
                <div class="text-block">
                    <h4>{{ $t('licencas') }}</h4>

                    <p>{{ $t('licencas-softwares-terceiros') }}</p>

                    <div class="separator"></div>

                    <div class="licenca-especifica">
                        <h6>{{ $t('licenca-n', { n: 'MIT' }) }}</h6>

                        <p>{{ $t('componentes-licenciados-n', { n: 'MIT' }) }}</p>

                        <ul>
                            <li>Vue.js</li>
                            <li>encoding-japanese</li>
                            <li>intl</li>
                            <li>jquery</li>
                            <li>jquery-ui</li>
                            <li>lottie-web</li>
                            <li>normalize.css</li>
                            <li>v-money</li>
                            <li>vue2-d3</li>
                            <li>vue2-google-maps</li>
                            <li>vue2-leaflet</li>
                            <li>vue2-timepicker</li>
                            <li>vuedraggable</li>
                            <li>vuex</li>
                            <li>@fortawesome/fontawesome-free</li>
                            <li>@vue/cli-plugin-babel</li>
                            <li>@vue/cli-plugin-unit-mocha</li>
                            <li>@vue/cli-service</li>
                            <li>@vue/test-utils</li>
                            <li>chai</li>
                            <li>css-loader</li>
                            <li>electron</li>
                            <li>node-sass</li>
                            <li>postcss-loader</li>
                            <li>sass-loader</li>
                            <li>vue-loader</li>
                            <li>vue-template-compiler</li>
                            <li>sendgrid-java</li>
                            <li>redis.clients.jedis</li>
                        </ul>

                        <pre class="license-text">
                            Permission is hereby granted, free of charge, to any person obtaining a copy
                            of this software and associated documentation files (the "Software"), to deal
                            in the Software without restriction, including without limitation the rights
                            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                            copies of the Software, and to permit persons to whom the Software is
                            furnished to do so, subject to the following conditions:

                            The above copyright notice and this permission notice shall be included in all
                            copies or substantial portions of the Software.

                            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                            SOFTWARE.
                        </pre>
                    </div>

                    <div class="separator"></div>

                    <div class="licenca-especifica">
                        <h6>{{ $t('licenca-n', { n: 'Apache 2.0' }) }}</h6>

                        <p>{{ $t('componentes-licenciados-n', { n: 'Apache 2.0' }) }}</p>

                        <ul>
                            <li>joda-time</li>
                            <li>org.apache.poi</li>
                            <li>spring-boot-starter-web</li>
                            <li>spring-boot-devtools</li>
                            <li>spring-boot-starter-test</li>
                            <li>spring-boot-starter-actuator</li>
                            <li>spring-jdbc</li>
                            <li>aws-java-sdk-s3</li>
                            <li>org.olap4j</li>
                            <li>google-maps-services</li>
                            <li>simple-java-mail</li>
                            <li>com.zaxxer.HikariCP</li>
                            <li>io.jsonwebtoken.jjwt</li>
                            <li>spring-boot-starter-security</li>
                            <li>commons-io</li>
                        </ul>

                        <pre class="license-text">
                            Licensed under the Apache License, Version 2.0 (the "License");
                            you may not use this file except in compliance with the License.
                            You may obtain a copy of the License at

                            <a href="http://www.apache.org/licenses/LICENSE-2.0">http://www.apache.org/licenses/LICENSE-2.0</a>

                            Unless required by applicable law or agreed to in writing, software
                            distributed under the License is distributed on an "AS IS" BASIS,
                            WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                            See the License for the specific language governing permissions and
                            limitations under the License.
                        </pre>
                    </div>

                    <div class="separator"></div>

                    <div class="licenca-especifica">
                        <h6>{{ $t('licenca-n', { n: 'LGPL' }) }}</h6>

                        <p>{{ $t('componentes-licenciados-n', { n: 'LGPL' }) }}</p>

                        <ul>
                            <li>jfreechart</li>
                            <li>net.sf.jasperreports</li>
                        </ul>

                        <pre class="license-text">
                            Copyright (C) 2007 Free Software Foundation, Inc. <a href="https://fsf.org/">https://fsf.org/</a>
                            Everyone is permitted to copy and distribute verbatim copies
                            of this license document, but changing it is not allowed.


                            This version of the GNU Lesser General Public License incorporates
                            the terms and conditions of version 3 of the GNU General Public
                            License, supplemented by the additional permissions listed below.

                            0. Additional Definitions.

                            As used herein, "this License" refers to version 3 of the GNU Lesser
                            General Public License, and the "GNU GPL" refers to version 3 of the GNU
                            General Public License.

                            "The Library" refers to a covered work governed by this License,
                            other than an Application or a Combined Work as defined below.

                            An "Application" is any work that makes use of an interface provided
                            by the Library, but which is not otherwise based on the Library.
                            Defining a subclass of a class defined by the Library is deemed a mode
                            of using an interface provided by the Library.

                            A "Combined Work" is a work produced by combining or linking an
                            Application with the Library.  The particular version of the Library
                            with which the Combined Work was made is also called the "Linked
                            Version".

                            The "Minimal Corresponding Source" for a Combined Work means the
                            Corresponding Source for the Combined Work, excluding any source code
                            for portions of the Combined Work that, considered in isolation, are
                            based on the Application, and not on the Linked Version.

                            The "Corresponding Application Code" for a Combined Work means the
                            object code and/or source code for the Application, including any data
                            and utility programs needed for reproducing the Combined Work from the
                            Application, but excluding the System Libraries of the Combined Work.

                            1. Exception to Section 3 of the GNU GPL.

                            You may convey a covered work under sections 3 and 4 of this License
                            without being bound by section 3 of the GNU GPL.

                            2. Conveying Modified Versions.

                            If you modify a copy of the Library, and, in your modifications, a
                            facility refers to a function or data to be supplied by an Application
                            that uses the facility (other than as an argument passed when the
                            facility is invoked), then you may convey a copy of the modified
                            version:

                            a) under this License, provided that you make a good faith effort to
                            ensure that, in the event an Application does not supply the
                            function or data, the facility still operates, and performs
                            whatever part of its purpose remains meaningful, or

                            b) under the GNU GPL, with none of the additional permissions of
                            this License applicable to that copy.

                            3. Object Code Incorporating Material from Library Header Files.

                            The object code form of an Application may incorporate material from
                            a header file that is part of the Library.  You may convey such object
                            code under terms of your choice, provided that, if the incorporated
                            material is not limited to numerical parameters, data structure
                            layouts and accessors, or small macros, inline functions and templates
                            (ten or fewer lines in length), you do both of the following:

                            a) Give prominent notice with each copy of the object code that the
                            Library is used in it and that the Library and its use are
                            covered by this License.

                            b) Accompany the object code with a copy of the GNU GPL and this license
                            document.

                            4. Combined Works.

                            You may convey a Combined Work under terms of your choice that,
                            taken together, effectively do not restrict modification of the
                            portions of the Library contained in the Combined Work and reverse
                            engineering for debugging such modifications, if you also do each of
                            the following:

                            a) Give prominent notice with each copy of the Combined Work that
                            the Library is used in it and that the Library and its use are
                            covered by this License.

                            b) Accompany the Combined Work with a copy of the GNU GPL and this license
                            document.

                            c) For a Combined Work that displays copyright notices during
                            execution, include the copyright notice for the Library among
                            these notices, as well as a reference directing the user to the
                            copies of the GNU GPL and this license document.

                            d) Do one of the following:

                                0) Convey the Minimal Corresponding Source under the terms of this
                                License, and the Corresponding Application Code in a form
                                suitable for, and under terms that permit, the user to
                                recombine or relink the Application with a modified version of
                                the Linked Version to produce a modified Combined Work, in the
                                manner specified by section 6 of the GNU GPL for conveying
                                Corresponding Source.

                                1) Use a suitable shared library mechanism for linking with the
                                Library.  A suitable mechanism is one that (a) uses at run time
                                a copy of the Library already present on the user's computer
                                system, and (b) will operate properly with a modified version
                                of the Library that is interface-compatible with the Linked
                                Version.

                            e) Provide Installation Information, but only if you would otherwise
                            be required to provide such information under section 6 of the
                            GNU GPL, and only to the extent that such information is
                            necessary to install and execute a modified version of the
                            Combined Work produced by recombining or relinking the
                            Application with a modified version of the Linked Version. (If
                            you use option 4d0, the Installation Information must accompany
                            the Minimal Corresponding Source and Corresponding Application
                            Code. If you use option 4d1, you must provide the Installation
                            Information in the manner specified by section 6 of the GNU GPL
                            for conveying Corresponding Source.)

                            5. Combined Libraries.

                            You may place library facilities that are a work based on the
                            Library side by side in a single library together with other library
                            facilities that are not Applications and are not covered by this
                            License, and convey such a combined library under terms of your
                            choice, if you do both of the following:

                            a) Accompany the combined library with a copy of the same work based
                            on the Library, uncombined with any other library facilities,
                            conveyed under the terms of this License.

                            b) Give prominent notice with the combined library that part of it
                            is a work based on the Library, and explaining where to find the
                            accompanying uncombined form of the same work.

                            6. Revised Versions of the GNU Lesser General Public License.

                            The Free Software Foundation may publish revised and/or new versions
                            of the GNU Lesser General Public License from time to time. Such new
                            versions will be similar in spirit to the present version, but may
                            differ in detail to address new problems or concerns.

                            Each version is given a distinguishing version number. If the
                            Library as you received it specifies that a certain numbered version
                            of the GNU Lesser General Public License "or any later version"
                            applies to it, you have the option of following the terms and
                            conditions either of that published version or of any later version
                            published by the Free Software Foundation. If the Library as you
                            received it does not specify a version number of the GNU Lesser
                            General Public License, you may choose any version of the GNU Lesser
                            General Public License ever published by the Free Software Foundation.

                            If the Library as you received it specifies that a proxy can decide
                            whether future versions of the GNU Lesser General Public License shall
                            apply, that proxy's public statement of acceptance of any version is
                            permanent authorization for you to choose that version for the
                            Library.
                        </pre>
                    </div>

                    <div class="separator"></div>

                    <div class="licenca-especifica">
                        <h6>{{ $t('licenca-n', { n: 'GPL 2.0' }) }}</h6>

                        <p>{{ $t('componentes-licenciados-n', { n: 'GPL 2.0' }) }}</p>

                        <ul>
                            <li>mysql-connector-java</li>
                        </ul>

                        <pre class="license-text">
                            This program is free software; you can redistribute it and/or
                            modify it under the terms of the GNU General Public License
                            as published by the Free Software Foundation; either version 2
                            of the License, or (at your option) any later version.

                            This program is distributed in the hope that it will be useful,
                            but WITHOUT ANY WARRANTY; without even the implied warranty of
                            MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
                            GNU General Public License for more details.

                            You should have received a copy of the GNU General Public License
                            along with this program; if not, write to the Free Software
                            Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
                        </pre>
                    </div>

                    <div class="separator"></div>

                    <div class="licenca-especifica">
                        <h6>{{ $t('licenca-n', { n: 'GPL 3.0' }) }}</h6>

                        <p>{{ $t('componentes-licenciados-n', { n: 'GPL 3.0' }) }}</p>

                        <ul>
                            <li>packery</li>
                        </ul>

                        <pre class="license-text">
                            This program is free software: you can redistribute it and/or modify
                            it under the terms of the GNU General Public License as published by
                            the Free Software Foundation, either version 3 of the License, or
                            (at your option) any later version.

                            This program is distributed in the hope that it will be useful,
                            but WITHOUT ANY WARRANTY; without even the implied warranty of
                            MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
                            GNU General Public License for more details.

                            You should have received a copy of the GNU General Public License
                            along with this program.  If not, see <a href="https://www.gnu.org/licenses/"> https://www.gnu.org/licenses/ </a>.
                        </pre>
                    </div>

                    <div class="separator"></div>

                    <div class="licenca-especifica">
                        <h6>{{ $t('licenca-n', { n: 'MPL 1.1' }) }}</h6>

                        <p>{{ $t('componentes-licenciados-n', { n: 'MPL 1.1' }) }}</p>

                        <ul>
                            <li>com.lowagie.itext</li>
                        </ul>

                        <pre class="license-text">
                            "The contents of this file are subject to the Mozilla Public License
                            Version 1.1 (the "License"); you may not use this file except in
                            compliance with the License. You may obtain a copy of the License at
                            <a href="https://www.mozilla.org/MPL/"> https://www.mozilla.org/MPL/</a>

                            Software distributed under the License is distributed on an "AS IS"
                            basis, WITHOUT WARRANTY OF ANY KIND, either express or implied. See the
                            License for the specific language governing rights and limitations
                            under the License.
                        </pre>
                    </div>

                    <div class="separator"></div>

                    <div class="licenca-especifica">
                        <h6>{{ $t('licenca-n', { n: 'CDDL 1.1' }) }}</h6>

                        <p>{{ $t('componentes-licenciados-n', { n: 'CDDL 1.1' }) }}</p>

                        <ul>
                            <li>javax.xml.bind.jaxb-api</li>
                        </ul>

                        <pre class="license-text">
                            COMMON DEVELOPMENT AND DISTRIBUTION LICENSE (CDDL) Version 1.1

                            1. Definitions.

                                1.1. "Contributor" means each individual or entity that creates or
                                contributes to the creation of Modifications.

                                1.2. "Contributor Version" means the combination of the Original
                                Software, prior Modifications used by a Contributor (if any), and
                                the Modifications made by that particular Contributor.

                                1.3. "Covered Software" means (a) the Original Software, or (b)
                                Modifications, or (c) the combination of files containing Original
                                Software with files containing Modifications, in each case including
                                portions thereof.

                                1.4. "Executable" means the Covered Software in any form other than
                                Source Code.

                                1.5. "Initial Developer" means the individual or entity that first
                                makes Original Software available under this License.

                                1.6. "Larger Work" means a work which combines Covered Software or
                                portions thereof with code not governed by the terms of this License.

                                1.7. "License" means this document.

                                1.8. "Licensable" means having the right to grant, to the maximum
                                extent possible, whether at the time of the initial grant or
                                subsequently acquired, any and all of the rights conveyed herein.

                                1.9. "Modifications" means the Source Code and Executable form of
                                any of the following:

                                A. Any file that results from an addition to, deletion from or
                                modification of the contents of a file containing Original Software
                                or previous Modifications;

                                B. Any new file that contains any part of the Original Software or
                                previous Modification; or

                                C. Any new file that is contributed or otherwise made available
                                under the terms of this License.

                                1.10. "Original Software" means the Source Code and Executable form
                                of computer software code that is originally released under this
                                License.

                                1.11. "Patent Claims" means any patent claim(s), now owned or
                                hereafter acquired, including without limitation, method, process,
                                and apparatus claims, in any patent Licensable by grantor.

                                1.12. "Source Code" means (a) the common form of computer software
                                code in which modifications are made and (b) associated
                                documentation included in or with such code.

                                1.13. "You" (or "Your") means an individual or a legal entity
                                exercising rights under, and complying with all of the terms of,
                                this License. For legal entities, "You" includes any entity which
                                controls, is controlled by, or is under common control with You. For
                                purposes of this definition, "control" means (a) the power, direct
                                or indirect, to cause the direction or management of such entity,
                                whether by contract or otherwise, or (b) ownership of more than
                                fifty percent (50%) of the outstanding shares or beneficial
                                ownership of such entity.

                            2. License Grants.

                                2.1. The Initial Developer Grant.

                                Conditioned upon Your compliance with Section 3.1 below and subject
                                to third party intellectual property claims, the Initial Developer
                                hereby grants You a world-wide, royalty-free, non-exclusive license:

                                (a) under intellectual property rights (other than patent or
                                trademark) Licensable by Initial Developer, to use, reproduce,
                                modify, display, perform, sublicense and distribute the Original
                                Software (or portions thereof), with or without Modifications,
                                and/or as part of a Larger Work; and

                                (b) under Patent Claims infringed by the making, using or selling of
                                Original Software, to make, have made, use, practice, sell, and
                                offer for sale, and/or otherwise dispose of the Original Software
                                (or portions thereof).

                                (c) The licenses granted in Sections 2.1(a) and (b) are effective on
                                the date Initial Developer first distributes or otherwise makes the
                                Original Software available to a third party under the terms of this
                                License.

                                (d) Notwithstanding Section 2.1(b) above, no patent license is
                                granted: (1) for code that You delete from the Original Software, or
                                (2) for infringements caused by: (i) the modification of the
                                Original Software, or (ii) the combination of the Original Software
                                with other software or devices.

                                2.2. Contributor Grant.

                                Conditioned upon Your compliance with Section 3.1 below and subject
                                to third party intellectual property claims, each Contributor hereby
                                grants You a world-wide, royalty-free, non-exclusive license:

                                (a) under intellectual property rights (other than patent or
                                trademark) Licensable by Contributor to use, reproduce, modify,
                                display, perform, sublicense and distribute the Modifications
                                created by such Contributor (or portions thereof), either on an
                                unmodified basis, with other Modifications, as Covered Software
                                and/or as part of a Larger Work; and

                                (b) under Patent Claims infringed by the making, using, or selling
                                of Modifications made by that Contributor either alone and/or in
                                combination with its Contributor Version (or portions of such
                                combination), to make, use, sell, offer for sale, have made, and/or
                                otherwise dispose of: (1) Modifications made by that Contributor (or
                                portions thereof); and (2) the combination of Modifications made by
                                that Contributor with its Contributor Version (or portions of such
                                combination).

                                (c) The licenses granted in Sections 2.2(a) and 2.2(b) are effective
                                on the date Contributor first distributes or otherwise makes the
                                Modifications available to a third party.

                                (d) Notwithstanding Section 2.2(b) above, no patent license is
                                granted: (1) for any code that Contributor has deleted from the
                                Contributor Version; (2) for infringements caused by: (i) third
                                party modifications of Contributor Version, or (ii) the combination
                                of Modifications made by that Contributor with other software
                                (except as part of the Contributor Version) or other devices; or (3)
                                under Patent Claims infringed by Covered Software in the absence of
                                Modifications made by that Contributor.

                            3. Distribution Obligations.

                                3.1. Availability of Source Code.

                                Any Covered Software that You distribute or otherwise make available
                                in Executable form must also be made available in Source Code form
                                and that Source Code form must be distributed only under the terms
                                of this License. You must include a copy of this License with every
                                copy of the Source Code form of the Covered Software You distribute
                                or otherwise make available. You must inform recipients of any such
                                Covered Software in Executable form as to how they can obtain such
                                Covered Software in Source Code form in a reasonable manner on or
                                through a medium customarily used for software exchange.

                                3.2. Modifications.

                                The Modifications that You create or to which You contribute are
                                governed by the terms of this License. You represent that You
                                believe Your Modifications are Your original creation(s) and/or You
                                have sufficient rights to grant the rights conveyed by this License.

                                3.3. Required Notices.

                                You must include a notice in each of Your Modifications that
                                identifies You as the Contributor of the Modification. You may not
                                remove or alter any copyright, patent or trademark notices contained
                                within the Covered Software, or any notices of licensing or any
                                descriptive text giving attribution to any Contributor or the
                                Initial Developer.

                                3.4. Application of Additional Terms.

                                You may not offer or impose any terms on any Covered Software in
                                Source Code form that alters or restricts the applicable version of
                                this License or the recipients' rights hereunder. You may choose to
                                offer, and to charge a fee for, warranty, support, indemnity or
                                liability obligations to one or more recipients of Covered Software.
                                However, you may do so only on Your own behalf, and not on behalf of
                                the Initial Developer or any Contributor. You must make it
                                absolutely clear that any such warranty, support, indemnity or
                                liability obligation is offered by You alone, and You hereby agree
                                to indemnify the Initial Developer and every Contributor for any
                                liability incurred by the Initial Developer or such Contributor as a
                                result of warranty, support, indemnity or liability terms You offer.

                                3.5. Distribution of Executable Versions.

                                You may distribute the Executable form of the Covered Software under
                                the terms of this License or under the terms of a license of Your
                                choice, which may contain terms different from this License,
                                provided that You are in compliance with the terms of this License
                                and that the license for the Executable form does not attempt to
                                limit or alter the recipient's rights in the Source Code form from
                                the rights set forth in this License. If You distribute the Covered
                                Software in Executable form under a different license, You must make
                                it absolutely clear that any terms which differ from this License
                                are offered by You alone, not by the Initial Developer or
                                Contributor. You hereby agree to indemnify the Initial Developer and
                                every Contributor for any liability incurred by the Initial
                                Developer or such Contributor as a result of any such terms You offer.

                                3.6. Larger Works.

                                You may create a Larger Work by combining Covered Software with
                                other code not governed by the terms of this License and distribute
                                the Larger Work as a single product. In such a case, You must make
                                sure the requirements of this License are fulfilled for the Covered
                                Software.

                            4. Versions of the License.

                                4.1. New Versions.

                                Oracle is the initial license steward and may publish revised and/or
                                new versions of this License from time to time. Each version will be
                                given a distinguishing version number. Except as provided in Section
                                4.3, no one other than the license steward has the right to modify
                                this License.

                                4.2. Effect of New Versions.

                                You may always continue to use, distribute or otherwise make the
                                Covered Software available under the terms of the version of the
                                License under which You originally received the Covered Software. If
                                the Initial Developer includes a notice in the Original Software
                                prohibiting it from being distributed or otherwise made available
                                under any subsequent version of the License, You must distribute and
                                make the Covered Software available under the terms of the version
                                of the License under which You originally received the Covered
                                Software. Otherwise, You may also choose to use, distribute or
                                otherwise make the Covered Software available under the terms of any
                                subsequent version of the License published by the license steward.

                                4.3. Modified Versions.

                                When You are an Initial Developer and You want to create a new
                                license for Your Original Software, You may create and use a
                                modified version of this License if You: (a) rename the license and
                                remove any references to the name of the license steward (except to
                                note that the license differs from this License); and (b) otherwise
                                make it clear that the license contains terms which differ from this
                                License.

                            5. DISCLAIMER OF WARRANTY.

                                COVERED SOFTWARE IS PROVIDED UNDER THIS LICENSE ON AN "AS IS" BASIS,
                                WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESSED OR IMPLIED,
                                INCLUDING, WITHOUT LIMITATION, WARRANTIES THAT THE COVERED SOFTWARE
                                IS FREE OF DEFECTS, MERCHANTABLE, FIT FOR A PARTICULAR PURPOSE OR
                                NON-INFRINGING. THE ENTIRE RISK AS TO THE QUALITY AND PERFORMANCE OF
                                THE COVERED SOFTWARE IS WITH YOU. SHOULD ANY COVERED SOFTWARE PROVE
                                DEFECTIVE IN ANY RESPECT, YOU (NOT THE INITIAL DEVELOPER OR ANY
                                OTHER CONTRIBUTOR) ASSUME THE COST OF ANY NECESSARY SERVICING,
                                REPAIR OR CORRECTION. THIS DISCLAIMER OF WARRANTY CONSTITUTES AN
                                ESSENTIAL PART OF THIS LICENSE. NO USE OF ANY COVERED SOFTWARE IS
                                AUTHORIZED HEREUNDER EXCEPT UNDER THIS DISCLAIMER.

                            6. TERMINATION.

                                6.1. This License and the rights granted hereunder will terminate
                                automatically if You fail to comply with terms herein and fail to
                                cure such breach within 30 days of becoming aware of the breach.
                                Provisions which, by their nature, must remain in effect beyond the
                                termination of this License shall survive.

                                6.2. If You assert a patent infringement claim (excluding
                                declaratory judgment actions) against Initial Developer or a
                                Contributor (the Initial Developer or Contributor against whom You
                                assert such claim is referred to as "Participant") alleging that the
                                Participant Software (meaning the Contributor Version where the
                                Participant is a Contributor or the Original Software where the
                                Participant is the Initial Developer) directly or indirectly
                                infringes any patent, then any and all rights granted directly or
                                indirectly to You by such Participant, the Initial Developer (if the
                                Initial Developer is not the Participant) and all Contributors under
                                Sections 2.1 and/or 2.2 of this License shall, upon 60 days notice
                                from Participant terminate prospectively and automatically at the
                                expiration of such 60 day notice period, unless if within such 60
                                day period You withdraw Your claim with respect to the Participant
                                Software against such Participant either unilaterally or pursuant to
                                a written agreement with Participant.

                                6.3. If You assert a patent infringement claim against Participant
                                alleging that the Participant Software directly or indirectly
                                infringes any patent where such claim is resolved (such as by
                                license or settlement) prior to the initiation of patent
                                infringement litigation, then the reasonable value of the licenses
                                granted by such Participant under Sections 2.1 or 2.2 shall be taken
                                into account in determining the amount or value of any payment or
                                license.

                                6.4. In the event of termination under Sections 6.1 or 6.2 above,
                                all end user licenses that have been validly granted by You or any
                                distributor hereunder prior to termination (excluding licenses
                                granted to You by any distributor) shall survive termination.

                            7. LIMITATION OF LIABILITY.

                                UNDER NO CIRCUMSTANCES AND UNDER NO LEGAL THEORY, WHETHER TORT
                                (INCLUDING NEGLIGENCE), CONTRACT, OR OTHERWISE, SHALL YOU, THE
                                INITIAL DEVELOPER, ANY OTHER CONTRIBUTOR, OR ANY DISTRIBUTOR OF
                                COVERED SOFTWARE, OR ANY SUPPLIER OF ANY OF SUCH PARTIES, BE LIABLE
                                TO ANY PERSON FOR ANY INDIRECT, SPECIAL, INCIDENTAL, OR
                                CONSEQUENTIAL DAMAGES OF ANY CHARACTER INCLUDING, WITHOUT
                                LIMITATION, DAMAGES FOR LOSS OF GOODWILL, WORK STOPPAGE, COMPUTER
                                FAILURE OR MALFUNCTION, OR ANY AND ALL OTHER COMMERCIAL DAMAGES OR
                                LOSSES, EVEN IF SUCH PARTY SHALL HAVE BEEN INFORMED OF THE
                                POSSIBILITY OF SUCH DAMAGES. THIS LIMITATION OF LIABILITY SHALL NOT
                                APPLY TO LIABILITY FOR DEATH OR PERSONAL INJURY RESULTING FROM SUCH
                                PARTY'S NEGLIGENCE TO THE EXTENT APPLICABLE LAW PROHIBITS SUCH
                                LIMITATION. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR
                                LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THIS EXCLUSION
                                AND LIMITATION MAY NOT APPLY TO YOU.

                            8. U.S. GOVERNMENT END USERS.

                                The Covered Software is a "commercial item," as that term is defined
                                in 48 C.F.R. 2.101 (Oct. 1995), consisting of "commercial computer
                                software" (as that term is defined at 48 C.F.R. ยง
                                252.227-7014(a)(1)) and "commercial computer software documentation"
                                as such terms are used in 48 C.F.R. 12.212 (Sept. 1995). Consistent
                                with 48 C.F.R. 12.212 and 48 C.F.R. 227.7202-1 through 227.7202-4
                                (June 1995), all U.S. Government End Users acquire Covered Software
                                with only those rights set forth herein. This U.S. Government Rights
                                clause is in lieu of, and supersedes, any other FAR, DFAR, or other
                                clause or provision that addresses Government rights in computer
                                software under this License.

                            9. MISCELLANEOUS.

                                This License represents the complete agreement concerning subject
                                matter hereof. If any provision of this License is held to be
                                unenforceable, such provision shall be reformed only to the extent
                                necessary to make it enforceable. This License shall be governed by
                                the law of the jurisdiction specified in a notice contained within
                                the Original Software (except to the extent applicable law, if any,
                                provides otherwise), excluding such jurisdiction's conflict-of-law
                                provisions. Any litigation relating to this License shall be subject
                                to the jurisdiction of the courts located in the jurisdiction and
                                venue specified in a notice contained within the Original Software,
                                with the losing party responsible for costs, including, without
                                limitation, court costs and reasonable attorneys' fees and expenses.
                                The application of the United Nations Convention on Contracts for
                                the International Sale of Goods is expressly excluded. Any law or
                                regulation which provides that the language of a contract shall be
                                construed against the drafter shall not apply to this License. You
                                agree that You alone are responsible for compliance with the United
                                States export administration regulations (and the export control
                                laws and regulation of any other countries) when You use, distribute
                                or otherwise make available any Covered Software.

                            10. RESPONSIBILITY FOR CLAIMS.

                                As between Initial Developer and the Contributors, each party is
                                responsible for claims and damages arising, directly or indirectly,
                                out of its utilization of rights under this License and You agree to
                                work with Initial Developer and Contributors to distribute such
                                responsibility on an equitable basis. Nothing herein is intended or
                                shall be deemed to constitute any admission of liability.

                            ------------------------------------------------------------------------

                            NOTICE PURSUANT TO SECTION 9 OF THE COMMON DEVELOPMENT AND DISTRIBUTION
                            LICENSE (CDDL)

                            The code released under the CDDL shall be governed by the laws of the
                            State of California (excluding conflict-of-law provisions). Any
                            litigation relating to this License shall be subject to the jurisdiction
                            of the Federal Courts of the Northern District of California and the
                            state courts of the State of California, with venue lying in Santa Clara
                            County, California.
                        </pre>
                    </div>

                    <div class="separator"></div>

                    <div class="licenca-especifica">
                        <h6>{{ $t('licenca-n', { n: 'CC-BY-4.0' }) }}</h6>

                        <p>{{ $t('componentes-licenciados-n', { n: 'CC-BY-4.0' }) }}</p>

                        <ul>
                            <li>@fortawesome/fontawesome-free: "^5.15.1"</li>
                        </ul>

                        <pre class="license-text">
                            Attribution 4.0 International

                            =======================================================================

                            Creative Commons Corporation ("Creative Commons") is not a law firm and
                            does not provide legal services or legal advice. Distribution of
                            Creative Commons public licenses does not create a lawyer-client or
                            other relationship. Creative Commons makes its licenses and related
                            information available on an "as-is" basis. Creative Commons gives no
                            warranties regarding its licenses, any material licensed under their
                            terms and conditions, or any related information. Creative Commons
                            disclaims all liability for damages resulting from their use to the
                            fullest extent possible.

                            Using Creative Commons Public Licenses

                            Creative Commons public licenses provide a standard set of terms and
                            conditions that creators and other rights holders may use to share
                            original works of authorship and other material subject to copyright
                            and certain other rights specified in the public license below. The
                            following considerations are for informational purposes only, are not
                            exhaustive, and do not form part of our licenses.

                                Considerations for licensors: Our public licenses are
                                intended for use by those authorized to give the public
                                permission to use material in ways otherwise restricted by
                                copyright and certain other rights. Our licenses are
                                irrevocable. Licensors should read and understand the terms
                                and conditions of the license they choose before applying it.
                                Licensors should also secure all rights necessary before
                                applying our licenses so that the public can reuse the
                                material as expected. Licensors should clearly mark any
                                material not subject to the license. This includes other CC-
                                licensed material, or material used under an exception or
                                limitation to copyright. More considerations for licensors:
                                wiki.creativecommons.org/Considerations_for_licensors

                                Considerations for the public: By using one of our public
                                licenses, a licensor grants the public permission to use the
                                licensed material under specified terms and conditions. If
                                the licensor's permission is not necessary for any reason--for
                                example, because of any applicable exception or limitation to
                                copyright--then that use is not regulated by the license. Our
                                licenses grant only permissions under copyright and certain
                                other rights that a licensor has authority to grant. Use of
                                the licensed material may still be restricted for other
                                reasons, including because others have copyright or other
                                rights in the material. A licensor may make special requests,
                                such as asking that all changes be marked or described.
                                Although not required by our licenses, you are encouraged to
                                respect those requests where reasonable. More considerations
                                for the public:
                                wiki.creativecommons.org/Considerations_for_licensees

                            =======================================================================

                            Creative Commons Attribution 4.0 International Public License

                            By exercising the Licensed Rights (defined below), You accept and agree
                            to be bound by the terms and conditions of this Creative Commons
                            Attribution 4.0 International Public License ("Public License"). To the
                            extent this Public License may be interpreted as a contract, You are
                            granted the Licensed Rights in consideration of Your acceptance of
                            these terms and conditions, and the Licensor grants You such rights in
                            consideration of benefits the Licensor receives from making the
                            Licensed Material available under these terms and conditions.


                            Section 1 -- Definitions.

                            a. Adapted Material means material subject to Copyright and Similar
                                Rights that is derived from or based upon the Licensed Material
                                and in which the Licensed Material is translated, altered,
                                arranged, transformed, or otherwise modified in a manner requiring
                                permission under the Copyright and Similar Rights held by the
                                Licensor. For purposes of this Public License, where the Licensed
                                Material is a musical work, performance, or sound recording,
                                Adapted Material is always produced where the Licensed Material is
                                synched in timed relation with a moving image.

                            b. Adapter's License means the license You apply to Your Copyright
                                and Similar Rights in Your contributions to Adapted Material in
                                accordance with the terms and conditions of this Public License.

                            c. Copyright and Similar Rights means copyright and/or similar rights
                                closely related to copyright including, without limitation,
                                performance, broadcast, sound recording, and Sui Generis Database
                                Rights, without regard to how the rights are labeled or
                                categorized. For purposes of this Public License, the rights
                                specified in Section 2(b)(1)-(2) are not Copyright and Similar
                                Rights.

                            d. Effective Technological Measures means those measures that, in the
                                absence of proper authority, may not be circumvented under laws
                                fulfilling obligations under Article 11 of the WIPO Copyright
                                Treaty adopted on December 20, 1996, and/or similar international
                                agreements.

                            e. Exceptions and Limitations means fair use, fair dealing, and/or
                                any other exception or limitation to Copyright and Similar Rights
                                that applies to Your use of the Licensed Material.

                            f. Licensed Material means the artistic or literary work, database,
                                or other material to which the Licensor applied this Public
                                License.

                            g. Licensed Rights means the rights granted to You subject to the
                                terms and conditions of this Public License, which are limited to
                                all Copyright and Similar Rights that apply to Your use of the
                                Licensed Material and that the Licensor has authority to license.

                            h. Licensor means the individual(s) or entity(ies) granting rights
                                under this Public License.

                            i. Share means to provide material to the public by any means or
                                process that requires permission under the Licensed Rights, such
                                as reproduction, public display, public performance, distribution,
                                dissemination, communication, or importation, and to make material
                                available to the public including in ways that members of the
                                public may access the material from a place and at a time
                                individually chosen by them.

                            j. Sui Generis Database Rights means rights other than copyright
                                resulting from Directive 96/9/EC of the European Parliament and of
                                the Council of 11 March 1996 on the legal protection of databases,
                                as amended and/or succeeded, as well as other essentially
                                equivalent rights anywhere in the world.

                            k. You means the individual or entity exercising the Licensed Rights
                                under this Public License. Your has a corresponding meaning.


                            Section 2 -- Scope.

                            a. License grant.

                                1. Subject to the terms and conditions of this Public License,
                                    the Licensor hereby grants You a worldwide, royalty-free,
                                    non-sublicensable, non-exclusive, irrevocable license to
                                    exercise the Licensed Rights in the Licensed Material to:

                                        a. reproduce and Share the Licensed Material, in whole or
                                        in part; and

                                        b. produce, reproduce, and Share Adapted Material.

                                2. Exceptions and Limitations. For the avoidance of doubt, where
                                    Exceptions and Limitations apply to Your use, this Public
                                    License does not apply, and You do not need to comply with
                                    its terms and conditions.

                                3. Term. The term of this Public License is specified in Section
                                    6(a).

                                4. Media and formats; technical modifications allowed. The
                                    Licensor authorizes You to exercise the Licensed Rights in
                                    all media and formats whether now known or hereafter created,
                                    and to make technical modifications necessary to do so. The
                                    Licensor waives and/or agrees not to assert any right or
                                    authority to forbid You from making technical modifications
                                    necessary to exercise the Licensed Rights, including
                                    technical modifications necessary to circumvent Effective
                                    Technological Measures. For purposes of this Public License,
                                    simply making modifications authorized by this Section 2(a)
                                    (4) never produces Adapted Material.

                                5. Downstream recipients.

                                        a. Offer from the Licensor -- Licensed Material. Every
                                        recipient of the Licensed Material automatically
                                        receives an offer from the Licensor to exercise the
                                        Licensed Rights under the terms and conditions of this
                                        Public License.

                                        b. No downstream restrictions. You may not offer or impose
                                        any additional or different terms or conditions on, or
                                        apply any Effective Technological Measures to, the
                                        Licensed Material if doing so restricts exercise of the
                                        Licensed Rights by any recipient of the Licensed
                                        Material.

                                6. No endorsement. Nothing in this Public License constitutes or
                                    may be construed as permission to assert or imply that You
                                    are, or that Your use of the Licensed Material is, connected
                                    with, or sponsored, endorsed, or granted official status by,
                                    the Licensor or others designated to receive attribution as
                                    provided in Section 3(a)(1)(A)(i).

                            b. Other rights.

                                1. Moral rights, such as the right of integrity, are not
                                    licensed under this Public License, nor are publicity,
                                    privacy, and/or other similar personality rights; however, to
                                    the extent possible, the Licensor waives and/or agrees not to
                                    assert any such rights held by the Licensor to the limited
                                    extent necessary to allow You to exercise the Licensed
                                    Rights, but not otherwise.

                                2. Patent and trademark rights are not licensed under this
                                    Public License.

                                3. To the extent possible, the Licensor waives any right to
                                    collect royalties from You for the exercise of the Licensed
                                    Rights, whether directly or through a collecting society
                                    under any voluntary or waivable statutory or compulsory
                                    licensing scheme. In all other cases the Licensor expressly
                                    reserves any right to collect such royalties.


                            Section 3 -- License Conditions.

                            Your exercise of the Licensed Rights is expressly made subject to the
                            following conditions.

                            a. Attribution.

                                1. If You Share the Licensed Material (including in modified
                                    form), You must:

                                        a. retain the following if it is supplied by the Licensor
                                        with the Licensed Material:

                                            i. identification of the creator(s) of the Licensed
                                                Material and any others designated to receive
                                                attribution, in any reasonable manner requested by
                                                the Licensor (including by pseudonym if
                                                designated);

                                            ii. a copyright notice;

                                        iii. a notice that refers to this Public License;

                                            iv. a notice that refers to the disclaimer of
                                                warranties;

                                            v. a URI or hyperlink to the Licensed Material to the
                                                extent reasonably practicable;

                                        b. indicate if You modified the Licensed Material and
                                        retain an indication of any previous modifications; and

                                        c. indicate the Licensed Material is licensed under this
                                        Public License, and include the text of, or the URI or
                                        hyperlink to, this Public License.

                                2. You may satisfy the conditions in Section 3(a)(1) in any
                                    reasonable manner based on the medium, means, and context in
                                    which You Share the Licensed Material. For example, it may be
                                    reasonable to satisfy the conditions by providing a URI or
                                    hyperlink to a resource that includes the required
                                    information.

                                3. If requested by the Licensor, You must remove any of the
                                    information required by Section 3(a)(1)(A) to the extent
                                    reasonably practicable.

                                4. If You Share Adapted Material You produce, the Adapter's
                                    License You apply must not prevent recipients of the Adapted
                                    Material from complying with this Public License.


                            Section 4 -- Sui Generis Database Rights.

                            Where the Licensed Rights include Sui Generis Database Rights that
                            apply to Your use of the Licensed Material:

                            a. for the avoidance of doubt, Section 2(a)(1) grants You the right
                                to extract, reuse, reproduce, and Share all or a substantial
                                portion of the contents of the database;

                            b. if You include all or a substantial portion of the database
                                contents in a database in which You have Sui Generis Database
                                Rights, then the database in which You have Sui Generis Database
                                Rights (but not its individual contents) is Adapted Material; and

                            c. You must comply with the conditions in Section 3(a) if You Share
                                all or a substantial portion of the contents of the database.

                            For the avoidance of doubt, this Section 4 supplements and does not
                            replace Your obligations under this Public License where the Licensed
                            Rights include other Copyright and Similar Rights.


                            Section 5 -- Disclaimer of Warranties and Limitation of Liability.

                            a. UNLESS OTHERWISE SEPARATELY UNDERTAKEN BY THE LICENSOR, TO THE
                                EXTENT POSSIBLE, THE LICENSOR OFFERS THE LICENSED MATERIAL AS-IS
                                AND AS-AVAILABLE, AND MAKES NO REPRESENTATIONS OR WARRANTIES OF
                                ANY KIND CONCERNING THE LICENSED MATERIAL, WHETHER EXPRESS,
                                IMPLIED, STATUTORY, OR OTHER. THIS INCLUDES, WITHOUT LIMITATION,
                                WARRANTIES OF TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR
                                PURPOSE, NON-INFRINGEMENT, ABSENCE OF LATENT OR OTHER DEFECTS,
                                ACCURACY, OR THE PRESENCE OR ABSENCE OF ERRORS, WHETHER OR NOT
                                KNOWN OR DISCOVERABLE. WHERE DISCLAIMERS OF WARRANTIES ARE NOT
                                ALLOWED IN FULL OR IN PART, THIS DISCLAIMER MAY NOT APPLY TO YOU.

                            b. TO THE EXTENT POSSIBLE, IN NO EVENT WILL THE LICENSOR BE LIABLE
                                TO YOU ON ANY LEGAL THEORY (INCLUDING, WITHOUT LIMITATION,
                                NEGLIGENCE) OR OTHERWISE FOR ANY DIRECT, SPECIAL, INDIRECT,
                                INCIDENTAL, CONSEQUENTIAL, PUNITIVE, EXEMPLARY, OR OTHER LOSSES,
                                COSTS, EXPENSES, OR DAMAGES ARISING OUT OF THIS PUBLIC LICENSE OR
                                USE OF THE LICENSED MATERIAL, EVEN IF THE LICENSOR HAS BEEN
                                ADVISED OF THE POSSIBILITY OF SUCH LOSSES, COSTS, EXPENSES, OR
                                DAMAGES. WHERE A LIMITATION OF LIABILITY IS NOT ALLOWED IN FULL OR
                                IN PART, THIS LIMITATION MAY NOT APPLY TO YOU.

                            c. The disclaimer of warranties and limitation of liability provided
                                above shall be interpreted in a manner that, to the extent
                                possible, most closely approximates an absolute disclaimer and
                                waiver of all liability.


                            Section 6 -- Term and Termination.

                            a. This Public License applies for the term of the Copyright and
                                Similar Rights licensed here. However, if You fail to comply with
                                this Public License, then Your rights under this Public License
                                terminate automatically.

                            b. Where Your right to use the Licensed Material has terminated under
                                Section 6(a), it reinstates:

                                1. automatically as of the date the violation is cured, provided
                                    it is cured within 30 days of Your discovery of the
                                    violation; or

                                2. upon express reinstatement by the Licensor.

                                For the avoidance of doubt, this Section 6(b) does not affect any
                                right the Licensor may have to seek remedies for Your violations
                                of this Public License.

                            c. For the avoidance of doubt, the Licensor may also offer the
                                Licensed Material under separate terms or conditions or stop
                                distributing the Licensed Material at any time; however, doing so
                                will not terminate this Public License.

                            d. Sections 1, 5, 6, 7, and 8 survive termination of this Public
                                License.


                            Section 7 -- Other Terms and Conditions.

                            a. The Licensor shall not be bound by any additional or different
                                terms or conditions communicated by You unless expressly agreed.

                            b. Any arrangements, understandings, or agreements regarding the
                                Licensed Material not stated herein are separate from and
                                independent of the terms and conditions of this Public License.


                            Section 8 -- Interpretation.

                            a. For the avoidance of doubt, this Public License does not, and
                                shall not be interpreted to, reduce, limit, restrict, or impose
                                conditions on any use of the Licensed Material that could lawfully
                                be made without permission under this Public License.

                            b. To the extent possible, if any provision of this Public License is
                                deemed unenforceable, it shall be automatically reformed to the
                                minimum extent necessary to make it enforceable. If the provision
                                cannot be reformed, it shall be severed from this Public License
                                without affecting the enforceability of the remaining terms and
                                conditions.

                            c. No term or condition of this Public License will be waived and no
                                failure to comply consented to unless expressly agreed to by the
                                Licensor.

                            d. Nothing in this Public License constitutes or may be interpreted
                                as a limitation upon, or waiver of, any privileges and immunities
                                that apply to the Licensor or You, including from the legal
                                processes of any jurisdiction or authority.


                            =======================================================================

                            Creative Commons is not a party to its public
                            licenses. Notwithstanding, Creative Commons may elect to apply one of
                            its public licenses to material it publishes and in those instances
                            will be considered the “Licensor.” The text of the Creative Commons
                            public licenses is dedicated to the public domain under the CC0 Public
                            Domain Dedication. Except for the limited purpose of indicating that
                            material is shared under a Creative Commons public license or as
                            otherwise permitted by the Creative Commons policies published at
                            creativecommons.org/policies, Creative Commons does not authorize the
                            use of the trademark "Creative Commons" or any other trademark or logo
                            of Creative Commons without its prior written consent including,
                            without limitation, in connection with any unauthorized modifications
                            to any of its public licenses or any other arrangements,
                            understandings, or agreements concerning use of licensed material. For
                            the avoidance of doubt, this paragraph does not form part of the
                            public licenses.

                            Creative Commons may be contacted at creativecommons.org.

                        </pre>
                    </div>

                    <div class="separator"></div>

                    <div class="licenca-especifica">
                        <h6>{{ $t('licenca-n', { n: 'OFL-1.1' }) }}</h6>

                        <p>{{ $t('componentes-licenciados-n', { n: 'OFL-1.1' }) }}</p>

                        <ul>
                            <li>@fortawesome/fontawesome-free: "^5.15.1"</li>
                        </ul>

                        <pre class="license-text">
                            This Font Software is licensed under the SIL Open Font License, Version 1.1.

                            This license is copied below, and is also available with a FAQ at: <a href="http://scripts.sil.org/OFL">http://scripts.sil.org/OFL</a>


                            SIL OPEN FONT LICENSE
                            Version 1.1 - 26 February 2007


                            PREAMBLE
                            The goals of the Open Font License (OFL) are to stimulate worldwide
                            development of collaborative font projects, to support the font creation
                            efforts of academic and linguistic communities, and to provide a free and
                            open framework in which fonts may be shared and improved in partnership
                            with others.

                            The OFL allows the licensed fonts to be used, studied, modified and
                            redistributed freely as long as they are not sold by themselves. The
                            fonts, including any derivative works, can be bundled, embedded,
                            redistributed and/or sold with any software provided that any reserved
                            names are not used by derivative works. The fonts and derivatives,
                            however, cannot be released under any other type of license. The
                            requirement for fonts to remain under this license does not apply
                            to any document created using the fonts or their derivatives.


                            DEFINITIONS
                            "Font Software" refers to the set of files released by the Copyright
                            Holder(s) under this license and clearly marked as such. This may
                            include source files, build scripts and documentation.

                            "Reserved Font Name" refers to any names specified as such after the
                            copyright statement(s).

                            "Original Version" refers to the collection of Font Software components as
                            distributed by the Copyright Holder(s).

                            "Modified Version" refers to any derivative made by adding to, deleting,
                            or substituting - in part or in whole - any of the components of the
                            Original Version, by changing formats or by porting the Font Software to a
                            new environment.

                            "Author" refers to any designer, engineer, programmer, technical
                            writer or other person who contributed to the Font Software.


                            PERMISSION & CONDITIONS
                            Permission is hereby granted, free of charge, to any person obtaining
                            a copy of the Font Software, to use, study, copy, merge, embed, modify,
                            redistribute, and sell modified and unmodified copies of the Font
                            Software, subject to the following conditions:

                            1) Neither the Font Software nor any of its individual components,
                            in Original or Modified Versions, may be sold by itself.

                            2) Original or Modified Versions of the Font Software may be bundled,
                            redistributed and/or sold with any software, provided that each copy
                            contains the above copyright notice and this license. These can be
                            included either as stand-alone text files, human-readable headers or
                            in the appropriate machine-readable metadata fields within text or
                            binary files as long as those fields can be easily viewed by the user.

                            3) No Modified Version of the Font Software may use the Reserved Font
                            Name(s) unless explicit written permission is granted by the corresponding
                            Copyright Holder. This restriction only applies to the primary font name as
                            presented to the users.

                            4) The name(s) of the Copyright Holder(s) or the Author(s) of the Font
                            Software shall not be used to promote, endorse or advertise any
                            Modified Version, except to acknowledge the contribution(s) of the
                            Copyright Holder(s) and the Author(s) or with their explicit written
                            permission.

                            5) The Font Software, modified or unmodified, in part or in whole,
                            must be distributed entirely under this license, and must not be
                            distributed under any other license. The requirement for fonts to
                            remain under this license does not apply to any document created
                            using the Font Software.


                            TERMINATION
                            This license becomes null and void if any of the above conditions are
                            not met.


                            DISCLAIMER
                            THE FONT SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
                            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF
                            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT
                            OF COPYRIGHT, PATENT, TRADEMARK, OR OTHER RIGHT. IN NO EVENT SHALL THE
                            COPYRIGHT HOLDER BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                            INCLUDING ANY GENERAL, SPECIAL, INDIRECT, INCIDENTAL, OR CONSEQUENTIAL
                            DAMAGES, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
                            FROM, OUT OF THE USE OR INABILITY TO USE THE FONT SOFTWARE OR FROM
                            OTHER DEALINGS IN THE FONT SOFTWARE.
                        </pre>
                    </div>

                    <div class="separator"></div>

                    <div class="licenca-especifica">
                        <h6>{{ $t('licenca-n', { n: 'ISC' }) }}</h6>

                        <p>{{ $t('componentes-licenciados-n', { n: 'ISC' }) }}</p>

                        <ul>
                            <li>electron-to-chromium</li>
                        </ul>

                        <pre class="license-text">
                            Permission to use, copy, modify, and/or distribute this software for any
                            purpose with or without fee is hereby granted, provided that the above
                            copyright notice and this permission notice appear in all copies.

                            THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
                            REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
                            AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
                            INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
                            LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
                            OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
                            PERFORMANCE OF THIS SOFTWARE.
                        </pre>
                    </div>

                    <div class="separator"></div>

                    <div class="text-block">
                        <h4>{{ $t('icones') }}</h4>
                        <div>
                            <div>
                                {{ $t('creditos-icones') }}
                                <a href="https://www.freepik.com" title="Freepik">Freepik</a> from
                                <a href="https://www.flaticon.com/br/" title="Flaticon"
                                    >www.flaticon.com</a
                                >
                            </div>

                            <div>
                                {{ $t('creditos-icones') }}
                                <a href="https://icons8.com" title="Icons8">Icons8</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    created() {},
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
        margin-bottom: 20px;
    }

    .svg-icons {
        height: 50px;
        width: 50px;
    }

    .separator {
        width: 100%;
        border-top: 1px solid $table-border;
        padding: 10px 0;
        text-align: center;
        margin-bottom: 10px;
        font-weight: 600;
        font-size: 18px;
    }

    .licenca-especifica {
        margin-bottom: 30px;
    }
}
</style>
